import ImageOptimize from '@/components/ImageOptimize'
import { PageType, PageTypeSuffix } from '@/constants'
import { useNotification, useStore } from '@/containers'
import { getTranslate } from '@/utils/api-interceptors'
import { parseNkWebConfig, toBottomMenu } from '@/utils/local-data'
import { Disclosure } from '@headlessui/react'
import Link from 'next/link'
import { useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { assetUrl } from '@/utils/asset-url'

const Footer = ({ pageType = '' }: { pageType?: string }) => {
  const { bottomMenu } = useStore()
  const { systemConfig } = useNotification()
  const resolvedBottomMenu = useMemo(() => {
    const nk = parseNkWebConfig(systemConfig?.Config_Json_web_nguyenkim)
    return nk ? toBottomMenu(nk) : bottomMenu
  }, [systemConfig, bottomMenu])

  return (
    <footer
      id='footer'
      className={`mx-auto w-full relative text-[#000] ${
        pageType == PageType.HOMEPAGE ? 'top-[-56px]' : ''
      } ${pageType == PageType.PRODUCT ? 'pb-[70px]' : ''}`}
    >
      <section className={`footerInfo pt-2 bg-white`}>
        <div className={`container mx-auto flex items-end justify-between`}>
          <div className='w-full'>
            <p className='text-base mb-2 font-bold leading-tight block'>
              LIÊN HỆ HOTLINE:
            </p>
            <div className='hotLine flex flex-wrap items-center gap-3 my-3'>
              {systemConfig?.companyPhone && (
                <div className='w-full'>
                  <p className='text-xl font-bold leading-tight text-[#f00]'>
                    {systemConfig?.companyPhone}
                  </p>
                  <p className='italic text-xs'>
                    {systemConfig?.companyLabelPhone}
                  </p>
                </div>
              )}
              {systemConfig?.companyPhone2 && (
                <div className='w-full'>
                  <p className='text-xl font-bold leading-tight text-[#f00]'>
                    {systemConfig?.companyPhone2}
                  </p>
                  <p className='italic text-xs'>
                    {systemConfig?.companyLabelPhone2}
                  </p>
                </div>
              )}
            </div>
            <ul className='text-xs'>
              <li>
                <span>Website: </span>
                <span>{systemConfig?.companyWebsite}</span>
              </li>
              <li>
                <span>Email: </span>
                <span>{systemConfig?.companyEmail}</span>
              </li>
            </ul>
            <div className='py-2 mt-4'>
              <Link
                className='block border border-[#AEAEAE] px-2 py-1 text-center'
                href={'/store'}
              >
                Hệ thống cửa hàng →
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={`bg-white`}>
        <div className={`container mx-auto flex justify-start flex-wrap`}>
          {resolvedBottomMenu &&
            resolvedBottomMenu.length > 0 &&
            resolvedBottomMenu.map((e, i) => (
              <Disclosure as={'div'} className={`w-full`} key={i}>
                {({ open }) => (
                  <>
                    <Disclosure.Button className='h-12 text-sm border-b border-b-white-500 w-full text-left relative'>
                      {getTranslate(e.name)}
                      <svg
                        className={`${
                          open ? 'rotate-180' : 'rotate-[-90deg]'
                        } w-4 h-4 absolute right-0 top-4`}
                        xmlns='http://www.w3.org/2000/svg'
                        fill='none'
                        viewBox='0 0 24 24'
                        stroke='#919499'
                        aria-hidden='true'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d={open ? 'M5 15l7-7 7 7' : 'M19 9l-7 7-7-7'}
                        />
                      </svg>
                    </Disclosure.Button>

                    <Disclosure.Panel>
                      {e.children && e.children.length > 0 && (
                        <ul>
                          {e.children.map(f => (
                            <li
                              key={uuidv4()}
                              className='mb-[4px] h-12 flex items-center text-sm pl-3 border-b border-b-white-500 '
                            >
                              {f.type === 'link' ? (
                                <a
                                  href={`${f.url}` || ''}
                                  className='block w-full'
                                >
                                  {getTranslate(f.name)}
                                </a>
                              ) : (
                                <a
                                  href={
                                    `/${f.slug + PageTypeSuffix.PAGE_CMS}` || ''
                                  }
                                >
                                  {getTranslate(f.name)}
                                </a>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
        </div>
      </section>

      <section className={`footerInfo bg-white`}>
        <div className={`mx-auto flex flex-wrap`}>
          <div className='w-full bg-[#F3F4F6] p-2'>
            <div className='grid grid-cols-2'>
              <ul className='mb-0 flex items-center'>
                <li className=''>
                  <Link
                    href={systemConfig?.companyFacebook?.trim() || '/'}
                    target='blank'
                    className='flex h-[36px] w-[36px] items-center justify-center rounded-full border border-gray-400'
                  >
                    <img
                      src={assetUrl('/assets/icons/footer/fb.svg')}
                      alt='Facebook'
                      className='h-[18px] w-[18px]'
                    />
                  </Link>
                </li>
                <li className='ml-2'>
                  <Link
                    href={systemConfig?.companyInstagram?.trim() || '/'}
                    className='flex h-[36px] w-[36px] items-center justify-center rounded-full border border-gray-400'
                    target='blank'
                  >
                    <img
                      src={assetUrl('/assets/icons/footer/instagram.svg')}
                      alt='Instagram'
                      className='h-[18px] w-[18px]'
                    />
                  </Link>
                </li>
                <li className='ml-2'>
                  <Link
                    href={systemConfig?.companyTikTok?.trim() || '/'}
                    target='blank'
                    className='flex h-[36px] w-[36px] items-center justify-center rounded-full border border-gray-400'
                  >
                    <img
                      src={assetUrl('/assets/icons/footer/tiktok.svg')}
                      alt='Tiktok'
                      className='h-[18px] w-[18px]'
                    />
                  </Link>
                </li>
                {systemConfig?.companyYoutube?.trim() && (
                  <li className='ml-2'>
                    <Link
                      href={systemConfig.companyYoutube.trim()}
                      target='blank'
                      className='flex h-[36px] w-[36px] items-center justify-center rounded-full border border-gray-400'
                    >
                      <img
                        src={assetUrl('/assets/icons/footer/yt.svg')}
                        alt='Youtube'
                        className='h-[18px] w-[18px]'
                      />
                    </Link>
                  </li>
                )}
              </ul>
              {systemConfig?.announcedMOIT && systemConfig?.companyVerify && (
                <Link
                  href={systemConfig?.companyVerify?.trim() || ''}
                  title='Đã thông báo'
                  target='blank'
                  className='ml-auto block'
                >
                  <ImageOptimize
                    width={111}
                    height={36}
                    src={systemConfig?.announcedMOIT || ''}
                    className='ml-auto h-auto'
                    alt='Đã thông báo'
                  />
                </Link>
              )}
            </div>
          </div>
          <div className='w-full mb-[48px] mt-6 font-[var(----font-mulish)] px-2'>
            <ul className='text-base leading-tight text-center'>
              <li className='font-bold mb-2'>
                <p>{getTranslate(systemConfig?.companyName)}</p>
              </li>
              <li className='italic text-xs'>
                <span>Giấy ĐKKD: </span>
                <span>{getTranslate(systemConfig?.businessLicense)}</span>
              </li>
              <li className='italic text-xs'>
                <span>Địa chỉ: </span>
                <span>{getTranslate(systemConfig?.companyAddress)}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </footer>
  )
}

export { Footer }
